export type InvitationKind = 'room' | 'world_football' | 'world_formula1'

export interface User {
  _id: string
  email: string
  name: string
}

export interface Room {
  _id: string
  name: string
  description?: string
  gameType?: string
}

export interface Invitation {
  _id: string
  room: Room | null
  sender: User
  recipient: User
  role?: string
  status: InvitationStatus
  kind?: InvitationKind
  requiresLocation?: boolean
  recipientEmail?: string
  createdAt: string
  updatedAt: string
}

export enum InvitationStatus {
  Pending = 'pending',
  Accepted = 'accepted',
  Rejected = 'rejected'
}

export function invitationTargetName(invitation: Invitation, t: (key: string) => string): string {
  if (invitation.kind === 'world_formula1') return t('invitations.worldFormula1')
  if (invitation.kind === 'world_football') return t('invitations.worldFootball')
  return invitation.room?.name || t('invitations.aRoom')
}

export function isInvitationRecipient(invitation: Invitation, user?: { _id?: string; id?: string; email?: string } | null): boolean {
  if (!user) return false
  const recipientId = String(invitation.recipient?._id || '').trim()
  const userId = String(user._id || user.id || '').trim()
  if (recipientId && userId && recipientId === userId) return true
  const inviteEmail = String(invitation.recipient?.email || invitation.recipientEmail || '').toLowerCase().trim()
  const userEmail = String(user.email || '').toLowerCase().trim()
  return !!inviteEmail && !!userEmail && inviteEmail === userEmail
}
